import { useBreadcrumb } from "features/breadcrumbs";
import DetalhePostagem from "./components/DetalharPostagem";
import { useParams } from "react-router";
import Container from "components/Container";

function MuralDetalhesPage() {
  const { id } = useParams() as { id: string };

  useBreadcrumb([
    { name: "Administração" },
    { name: "Mural", url: "/administracao/mural" },
    {
      name: id ? "Editar postagem" : "Criar postagem",
    },
  ]);

  return (
    <Container>
      <DetalhePostagem />
    </Container>
  );
}

export default MuralDetalhesPage;
